import generator from 'url-routes-generator';

export const Routes = {
  categories: ( permalink: string ) => generator.build( '/categories/:permalink', { permalink })(),
};
